import { createApp } from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura'
import Paginate from 'vuejs-paginate-next'
import { GChart } from 'vue-google-charts'
import 'primeicons/primeicons.css'
import { store } from './_store'
import { router, globalComponents } from './_helpers'
import { authenticationService } from './_services'
import i18n from './plugins/i18n'
import vuetify from './plugins/vuetify'
import './assets/css/vuetify2-compat.css'
import modal from './plugins/modal'
import chatScroll from './plugins/chat-scroll'
import { currency, toCurrency } from './filters'
import ProgressBar from './components/ProgressBar.vue'
import PeriodSelect from './components/PeriodSelect.vue'
import { isCurrentPeriod, yearsBack } from './_helpers/period'
import Donut from './components/donut/Donut.vue'
import App from './app/App'

window.axios = axios
axios.defaults.baseURL = '/api'

// Send the login token with every API call (the server requires it everywhere except sign-in and password reset)
axios.interceptors.request.use(config => {
  const user = authenticationService.currentUserValue
  if (user && user.token && !(config.headers && config.headers.Authorization)) {
    config.headers.Authorization = 'Bearer ' + user.token
  }
  return config
})

// A rejected token (expired, user removed or deactivated) signs the user out and returns them to the login page
axios.interceptors.response.use(response => response, error => {
  if (error.response && error.response.status === 401 && authenticationService.currentUserValue) {
    authenticationService.logout()
    router.push({ path: '/login', query: { returnUrl: router.currentRoute.value.fullPath } })
  }
  return Promise.reject(error)
})

const app = createApp(App)

app.use(router)
app.use(store)
app.use(i18n)
app.use(vuetify)
app.use(modal)
app.use(chatScroll)
app.use(VueAxios, axios)
app.use(PrimeVue, { theme: { preset: Aura } })

Object.entries(globalComponents).forEach(([name, component]) => {
  app.component(name, component)
})
app.component('paginate', Paginate)
app.component('GChart', GChart)
app.component('progress-bar', ProgressBar)
app.component('period-select', PeriodSelect)
app.component('vc-donut', Donut)

// Vue 3 removed filters: templates call $filters.currency(value, symbol) / $filters.toCurrency(value)
app.config.globalProperties.$filters = { currency, toCurrency }
// Year filter helpers (period 0 = next year, 1 = current year, 2 = last year, ...)
app.config.globalProperties.$period = { isCurrent: isCurrentPeriod, yearsBack }

app.mount('#app')
